import * as React from "react";
// import _ from "lodash";
import { Fragment } from "react";
import {
  IFilterData,
  BaseListComponentState,
} from "../../../components/BaseListComponent";
import {
  createFilterData,
  mapEntityList,
} from "./../../../services/utility/autoMapperService";
import BaseListComponent from "./../../../components/BaseListComponent";
import ItemsTable, {
  filterFieldData,
} from "../../../components/tableComponents/itemsTable";
import TableFilterPane from "./../../../components/tableComponents/tableFilterPane";
import sweepPlanService from "../../../services/sweep/sweepPlanService";
import SweepPlanDetail from "./sweepPlanDetail";

export interface SweepPlansProps {}

export interface SweepPlansState extends BaseListComponentState {
  data: IFilterData;
  currentPage: number;
  pageSize: number;
  tableItems: any;
  totalSize: number;
  fetchingDetail: boolean;
  filterValueInput: filterFieldData;
  item: any;
}

class SweepPlansList extends BaseListComponent<SweepPlansState> {}

class SweepPlans extends React.Component<
  SweepPlansProps,
  SweepPlansState
> {
  constructor(props: SweepPlansProps) {
    super(props);
    this.state = {
      data: createFilterData([
        "sweepPlanReference",
        "loanAccountNo",
        "sweepAmount",
        "sweepPlanStatus",
        // "startTime",
        // "endTime",
      ]) as IFilterData,
      currentPage: 1,
      pageSize: Number(process.env.REACT_APP_DEFAULT_PAGESIZE) || 10,
      fetching: false,
      fetchingDetail: false,
      tableItems: [],
      totalSize: 0,
      filterValueInput: [
        { name: "sweepPlanReference", fieldType: "text", value: "" },
        { name: "loanAccountNo", fieldType: "text", value: "" },
        { name: "sweepAmount", fieldType: "number", value: "" },
        {
          name: "sweepPlanStatus",
          fieldType: "select",
          options: [
            "Started",
            "Waiting",
            "Completed"
          ],
          value: "",
        },
        // { name: "startTime", fieldType: "date", value: "" },
        // { name: "endTime", fieldType: "date", value: "" },
      ],
      item: {},
      showDetailsModal: false,
      showEditModal: false,
      showTableFilterModal: false,
      showTrailModal: false,
    };
  }

  handlePageChange = async (currentPage: number, pageSize:number, data?: IFilterData) => {
    currentPage = currentPage < 0 ? this.state.currentPage : currentPage;
    pageSize = pageSize < 0 ? this.state.pageSize : pageSize;
    this.setState({ fetching: true });
    // const decodedToken = decodeToken(getCurrentUserSession().token || "");
    data = typeof data === "undefined" ? this.state.data : data;
    try {
      const sweepPlans = await sweepPlanService.filterSweepPlans(
        data,
        pageSize,
        currentPage
      );
      // console.log("sweepPlans: ", sweepPlans);
      this.setState({
        tableItems: mapEntityList({
          entityList: sweepPlans.data.item2,
          properties: [
            { oldName: "sweepPlanReference", newName: "sweepPlanReference" },
            { oldName: "loanAccountNo", newName: "loanAccountNo" },
            { oldName: "sweepAmount", newName: "sweepAmount" },
            { oldName: "amountInitiated", newName: "amountInitiated" },
            { oldName: "amountDebited", newName: "amountDebited" },
            {
              isTag: true,
              oldName: "sweepPlanStatus",
              newName: "sweepPlanStatus",
              success: "Completed",
              danger: "danger",
              default: "Started",
              primary: "Waiting",
              secondary: "secondary",
              warning: "warning",
              light: "light",
              dark: "dark",
            },
            { oldName: "startTime", newName: "startTime" },
            { oldName: "endTime", newName: "endTime" },
          ]
        }),
        currentPage,
        pageSize,
        totalSize: sweepPlans.data.item1,
        fetching: false,
      });
    } catch (ex) {
      // console.log("caught exception", ex.response);
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status <= 499
      ) {
        // toast.error("Bad Request");
        // console.log(ex.response);
        // errors["response"] = "Internal server error.";
        // console.log(errors);
        // this.setState({ errors, fetching: false });
      } else {
        // toast.error("Internal server error. Please contact the admin.");
        // this.setState({ errors, fetching: false });
      }
    }
  };

  handleOnExport = async (type: string) => {};

  fetchItemById = async (item: any) => {
    // await activityTrailService.saveActivityTrail({
    //   actionType: "View Details",
    //   description: `Viewed details of Branch ${item.name}`
    // });
    this.setState({ fetchingDetail: true });
    // console.log("fetching branch with id: ", item.id);
    const sweepPlan = await sweepPlanService.retrieveById(
      item.id
    );
    // console.log("consent sweepPlan: ", sweepPlan.data);
    this.setState({ item: sweepPlan.data, fetchingDetail: false });
  };

  getFilteredItems = (data: IFilterData): IFilterData => {
    let filteredItems: IFilterData = {};
    Object.keys(data).forEach((key) => {
      if (data[key].item2 !== "") {
        filteredItems[key] = data[key];
      }
    });
    return filteredItems;
  };

  async componentDidMount() {
    this.handlePageChange(this.state.currentPage, this.state.pageSize);
  }

  render() {
    const {
      // data,
      currentPage,
      pageSize,
      tableItems,
      totalSize,
      fetching,
      item,
      fetchingDetail,
    } = this.state;
    // let filteredItems: IFilterData = {};
    // Object.keys(data).forEach((key) => {
    //   if (data[key].item2 !== "") {
    //     filteredItems[key] = data[key];
    //   }
    // });
    // console.log("data", data);
    // console.log("filteredItems", filteredItems);
    return (
      <Fragment>
        <div className="container-fluid relative animatedParent animateOnce">
          <div className="animated fadeInUpShort go">
            <div className="row my-3 mx-2">
              <h3>
                <b>Sweep Plans</b>
              </h3>
            </div>
            <SweepPlansList
              pageChangeHandler={this.handlePageChange}
              fetchingDetail={fetchingDetail}
              initialValues={{
                data: this.state.data,
                fetching: false,
                showDetailsModal: false,
                showEditModal: false,
                showTableFilterModal: false,
                showTrailModal: false,
                tableItems: [],
                filterValueInput: this.state.filterValueInput,
                item: {},
              }}
              tableItems={tableItems}
              item={item}
              DetailsModal={({
                item,
                onToggleDetailsModal,
                onToggleEditModal,
                showDetailsModal,
                showEditModal,
              }) => (
                <Fragment>
                  <SweepPlanDetail
                    showDetailsModal={showDetailsModal}
                    toggleDetailsModal={onToggleDetailsModal}
                    handlePageChange={this.handlePageChange}
                    item={item}
                  />
                </Fragment>
              )}
              ListPayLoad={({
                data,
                showTableFilterModal,
                tableItems,
                onToggleDetailsModal,
                onToggleTableFilterModal,
                onHandleFilterItemRemove,
                filterValueInput,
              }) => (
                <div className="row">
                  <div className="col-md-12">
                    <div className="card no-b">
                      <div className="card-body">
                        <div className="card-title">
                          <div id="list-filters" className="ml-4 mr-4">
                            <TableFilterPane
                              filteredItems={this.getFilteredItems(data)}
                              handleFilterRemove={onHandleFilterItemRemove}
                            />
                          </div>
                          <div id="list-table">
                            <ItemsTable
                              data={data}
                              items={tableItems}
                              filterValueInput={filterValueInput}
                              showTableFiltermodal={showTableFilterModal}
                              toggleTableFiltermodal={onToggleTableFilterModal}
                              name="SweepPlans"
                              currentPage={currentPage}
                              pageSize={pageSize}
                              totalSize={totalSize}
                              fetching={fetching}
                              handlePageChange={this.handlePageChange}
                              onViewDetails={(item: any) => {
                                this.fetchItemById(item);
                                onToggleDetailsModal();
                              }}
                              handleOnExport={this.handleOnExport}
                              amountColumn={["sweepAmount", "amountInitiated", "amountDebited"]}
                              timeColumn={["startTime", "endTime"]}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            ></SweepPlansList>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default SweepPlans;
